import { useEffect, useState } from "react";
import { getStepInstruments } from "../../../Requests/stepRequests";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import { getDeltaHedgeAccountsDropdown } from "../../../Requests/deltaHedgeAccounts";
import { DropdownItem } from "../../../Interfaces/dropdownInterfaces";
import { TableCell, TableRow } from "@mui/material";
import { addSeperatorToInput, stringifyNumbers } from "../../../helper";
import { StepOrderSide } from "../../../Interfaces/stepInterfaces";
import StaticDropdown from "../../../Components/Dropdown/StaticDropdown";
import { INLegsAddOrderFormValues } from "../../../Interfaces/nLegsInterfaces";
import CompactOrderPreviewTable from "../../../Components/CompactOrderPreviewTable";
import OrderPreviewInstrument, { PreviewInstrumentHeader, PreviewInstrumentOption } from "../../../Components/OrderPreviewInstrument";

interface IProps {
  values: INLegsAddOrderFormValues[];
  offsetSide: number;
}

const NLegOrderPreviewTable = ({ values }: IProps) => {
  const [options, setOptions] = useState<PreviewInstrumentOption[]>([]);
  const [users, setUsers] = useState([] as DropdownItem[]);

  useEffect(() => {
    getStepInstruments()
      .then((resp) => {
        setOptions(resp);
      })
      .catch(packetErrorHandler);
    getDeltaHedgeAccountsDropdown()
      .then((resp) => {
        setUsers(resp);
      })
      .catch(packetErrorHandler);
  }, []);

  const getHeader = () => (
    <>
      <TableCell>اکانت</TableCell>
      <TableCell>نسبت</TableCell>
      <>
        {values[0]?.uNLegsItems.map((_, i) => (
          <>
            <TableCell
              className={
                values[0]?.uNLegsItems[i].orderSide === StepOrderSide.Buy
                  ? "!text-green-600"
                  : values[0]?.uNLegsItems[i].orderSide === StepOrderSide.Sell
                  ? "!text-red-700"
                  : "!text-gray-600"
              }
            >
              <PreviewInstrumentHeader>نماد {stringifyNumbers(i + 1)}</PreviewInstrumentHeader>
            </TableCell>
            <TableCell
              className={
                values[0]?.uNLegsItems[i].orderSide === StepOrderSide.Buy
                  ? "!text-green-600"
                  : values[0]?.uNLegsItems[i].orderSide === StepOrderSide.Sell
                  ? "!text-red-700"
                  : "!text-gray-600"
              }
            >
              حجم {stringifyNumbers(i + 1)}
            </TableCell>
          </>
        ))}
      </>

      <TableCell>حداکثر بهای<br />تمام شده</TableCell>
    </>
  );

  const doNothing = () => {};

  const getBody = () => (
    <>
      {values ? (
        values.map((v) => (
          <TableRow>
            <TableCell>
              <StaticDropdown
                dropdown={{ name: "", placeholder: "", disabled: true }}
                onChange={doNothing}
                value={v.userId?.toString()}
                options={users}
              />
            </TableCell>

            <TableCell>
              <div className="flex flex-row justify-start items-center">
                {v.uNLegsItems.map((item, i) => (
                  <>
                    <div
                      className={`${
                        item.orderSide === StepOrderSide.Buy
                          ? "text-green-600"
                          : item.orderSide === StepOrderSide.Sell
                          ? "text-red-700"
                          : "text-gray-600"
                      }`}
                    >
                      {item.ratio}
                    </div>
                    {i !== v.uNLegsItems.length - 1 ? <div>-</div> : <></>}
                  </>
                ))}
              </div>
            </TableCell>
            {v.uNLegsItems.map((item, i) => (
              <>
                <TableCell>
                  <OrderPreviewInstrument
                    name={options.find(option => String(option.id) === String(item.instrumentId))?.name}
                    orderSide={item.orderSide}
                    optionOrderType={item.optionOrderType}
                    instrumentType={options.find(option => String(option.id) === String(item.instrumentId))?.type}
                  />
                </TableCell>
                <TableCell>
                  {Math.round(parseInt(item.volume?.toString())) || "-"}
                </TableCell>
              </>
            ))}

            <TableCell>
              {addSeperatorToInput(v.maxPairPosition, "priceWithDecimal")}
            </TableCell>
          </TableRow>
        ))
      ) : (
        <TableRow className="!relative h-10 !w-full">
          <TableCell className="!w-full !m-auto !flex !justify-center !items-center !h-full !absolute">
            موردی یافت نشد
          </TableCell>
        </TableRow>
      )}
    </>
  );

  return <CompactOrderPreviewTable header={getHeader()} body={getBody()} />;
};

export default NLegOrderPreviewTable;
